<template>
    <div>
        <div class="pay-page" v-loading.fullscreen="loading">
            <div class="content-wrapper">
                <span class="explain">请先支付主播录制费用</span>
                <span>预计字数: {{ payInstance.totalWords}} 字</span>
                <span>演播时长: {{ payInstance.totalDuration }} 小时</span>
                <span>任务酬劳: {{ payInstance.unitPrice.direct.multiplier }}{{ payInstance.unitPrice.direct.name }}</span>
                <span>预计总酬劳: {{ payInstance.amount }}{{ payInstance.unitPrice.direct.name }}</span>
            </div>
            <div v-html="postData"></div>
            <div class="buttons">
                <el-button type="primary" @click="getAjaxInfo">{{ $t('comb.toPay') }}</el-button>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    export default {
        components: {
          axios
        },
        data() {
            return {
                postData: '',
                loading: true,
                payInstance: {
                  unitPrice: {
                    direct: {},
                    inverse: {}
                  },
                  cashierVo: {
                    param: {}
                  }
                }
            }
        },
        methods: {
            init () {
              const that = this;
              axios.get(`/api/requirement/order/${that.$route.params.requirementId}`).then( res => {
                if (res.data.code === 200) {
                  that.payInstance = res.data.data;
                  that.loading = false;
                } else {
                  that.$message({
                    type: 'warning',
                    message: res.data.message,
                    duration: 1500
                  });
                }
              });
            },
          getAjaxInfo () {
            const that = this;
            that.payInstance.cashierVo.needPay?
              $.ajax({
                url: that.payInstance.cashierVo.cashierAddress,
                type: 'POST',
                data: that.payInstance.cashierVo.param,
                xhrFields: {
                  withCredentials: true
                },
                crossDomain: true,
                success: function(res) {
                  that.postData = res.cashierInfo;
                  that.loading = true;
                  setTimeout(function() {
                    document.forms['cashier_form'].submit();
                  }, 300)
                }
              }): location.href = this.payInstance.cashierVo.cashierAddress
          }
        },
        computed: {

        },
        created () {
          this.init();
        }
    }

</script>
<style lang="sass">
    @import "../../../sass/copyright/pay/toPayPage.scss";
</style>



// WEBPACK FOOTER //
// ToPayPage.vue?9832991e